<!-- KsRankTable.vue -->
<template>
  <div class="rank-table-container">
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px;color: white;">快手互动玩法榜</div>
      <div style="font-size: 20px;font-weight:bold;margin-top: 1%">{{ displayTime }}</div>
    </div>

    <!-- 加载中 -->
    <el-dialog
        v-model="isLoading"
        width="300px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="loading-dialog"
    >
      <div style="text-align:center; font-size: 24px; margin-bottom: 10px;">数据加载中，请稍后…</div>
      <div style="text-align:center;"><el-icon><Loading /></el-icon></div>
    </el-dialog>

    <!-- 自定义查询 -->
    <div v-if="selectedTab === '自定义查询'" class="custom-query-container">
      <div class="datetime-container background-box">

        <!-- 非 Mate 三榜：保留开始/结束 + 小时 -->
        <template v-if="!isMateCategory">
          <div class="datetime-group">
            <label style="margin-right: 2%;margin-left: 2%;margin-top:2%">开始: </label>
            <span style="display:block;width:40%;">
              <datetime
                  input-style="width:100%;font-size:16px;"
                  v-model="startDate"
                  type="date"
                  :format="{year:'numeric',month:'2-digit',day:'2-digit'}"
                  :max-datetime="new Date().toISOString()"
                  class="dt-input"
              />
            </span>
            <el-button
                type="primary"
                style="width: 25%;margin-left:12%;margin-right: 2%"
                @click="showHourModal('start')"
            >
              {{ startHour ? startHour + '时' : '选择小时' }}
            </el-button>
          </div>

          <div class="datetime-group">
            <label style="margin-right: 2%;margin-left: 2%;margin-top:2%">结束:</label>
            <span style="display:block;width:40%;">
              <datetime
                  input-style="width:100%;font-size:16px;"
                  v-model="endDate"
                  type="date"
                  :format="{year:'numeric',month:'2-digit',day:'2-digit'}"
                  :max-datetime="new Date().toISOString()"
                  class="dt-input"
              />
            </span>
            <el-button
                type="primary"
                style="width: 25%;margin-left:12%;margin-right: 2%"
                @click="showHourModal('end')"
            >
              {{ endHour ? endHour + '时' : '选择小时' }}
            </el-button>
          </div>
        </template>

        <!-- Mate 三榜：仅按“日期” -->
        <template v-else>
          <div class="datetime-group">
            <label style="margin-right: 2%;margin-left: 2%;margin-top:2%">日期:</label>
            <span style="display:block;width:40%;">
              <datetime
                  input-style="width:100%;font-size:16px;"
                  v-model="startDate"
                  type="date"
                  :format="{year:'numeric',month:'2-digit',day:'2-digit'}"
                  :max-datetime="new Date().toISOString()"
                  class="dt-input"
              />
            </span>
          </div>
        </template>
      </div>

      <div class="form-row background-box">
        <label style="margin-left:2%;margin-top:1%;margin-right: 1%">榜单:</label>
        <el-button type="primary" style="width: 15%;margin-right: 1%;" @click="showCategoryModal">
          {{ selectedCategory }}
        </el-button>

        <!-- 玩法榜：自动补全 -->
        <div
            v-if="selectedCategory==='玩法榜'"
            class="custom-autocomplete"
            style="width: 30%;margin-right: 2%;font-size: 16px;padding:4px; position: relative;"
        >
          <input
              ref="autocompleteInput"
              v-model="searchQuery"
              type="text"
              placeholder="请输入玩法名"
              @focus="showDropdown"
              @input="onSearchInput"
              @blur="hideSuggestions"
              class="autocomplete-input"
              style="width:100%;font-size:16px;padding:4px"
          />
          <div v-if="showSuggestions" class="autocomplete-dropdown" :style="dropdownStyle">
            <ul>
              <li v-for="item in filteredSuggestions" :key="item.value" @click="onGameSelect(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>

        <!-- 其它榜单（主播榜/Mate 三榜）：普通输入 -->
        <div v-else style="min-width:45%;margin-right:2%;">
          <input
              v-model="searchQuery"
              :placeholder="inputPlaceholder"
              style="width: 30%;margin-right: 2%;font-size: 16px;padding:4px"
          />
        </div>

        <el-button type="primary" style="width: 15%;margin-right: 2%;" @click="showQuickSelectModal">
          快速选择
        </el-button>

        <el-button type="primary" @click="onSearch" style="width: 15%;margin-right: 2%;">查询</el-button>
      </div>
    </div>

    <!-- 榜单选择弹出框 -->
    <el-dialog v-model="categoryModalVisible" width="40%" title="选择榜单">
      <div class="category-select-container">
        <el-button
            v-for="category in categories"
            :key="category"
            style="width: 100%; margin: 10px 0;"
            @click="selectCategory(category)"
        >
          {{ category }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="categoryModalVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 小时选择弹出框 -->
    <el-dialog v-model="hourModalVisible" width="400px" title="选择小时">
      <div class="hour-selector">
        <el-button
            v-for="h in 24"
            :key="h"
            style="width: 22%; margin: 1%;"
            @click="selectHour(h - 1)"
        >
          {{ h - 1 }}时
        </el-button>
      </div>
    </el-dialog>

    <!-- 快速选择弹出框 -->
    <el-dialog v-model="quickSelectModalVisible" width="60%" title="快速选择">
      <div class="quick-select-container">
        <div
            class="quick-select-option"
            v-for="option in quickOptions"
            :key="option.value"
            @click="quickSelect = option.value"
        >
          <span class="option-label">{{ option.label }}</span>
          <el-radio :label="option.value" v-model="quickSelect" class="option-radio"></el-radio>
        </div>
      </div>
      <template #footer>
        <el-button @click="quickSelectModalVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuickSelect">确定</el-button>
      </template>
    </el-dialog>

    <!-- 顶部tab -->
    <div class="button-group" style="margin-top: 3%;">
      <el-button
          class="my-custom-button"
          style="margin-top: 1%;margin-right: 2%"
          v-for="btn in tabs"
          :key="btn"
          type="primary"
          :plain="selectedTab !== btn"
          @click="onTabClick(btn)"
      >
        {{ btn }}
      </el-button>
    </div>

    <!-- 排行榜表格 -->
    <el-table
        v-if="selectedTab !== '大盘数据'"
        :data="visibleRows"
        style="width: 100%; margin-top: 16px;"
        :header-row-style="headerRowStyle"
        :header-cell-style="headerCellStyle"
        :row-class-name="getRowClassName"
        :style="{ 'table-layout': 'fixed','border-radius':'clamp(10px, 2.5vw, 40px)'}"
    >
      <el-table-column
          v-for="col in columnsMap[selectedTab]"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :min-width="col.minWidth"
          align="center"
          :header-cell-style="headerCellStyle"
      >
        <template #default="{ row }">
          <!-- 活跃主播：可点拉侧边栏 -->
          <div v-if="col.prop === 'anchor_num'">
            <template v-if="row.game_name === '小计' || row.game_name === '总计'">
              <span>{{ row.anchor_num }}</span>
            </template>
            <template v-else>
              <span class="clickable-blue" @click="fetchAnchorData(row.game_name)">{{ row.anchor_num }}</span>
            </template>
          </div>

          <!-- 类别：可点击做品类过滤 -->
          <div v-else-if="col.prop === 'category'">
            <template v-if="row[col.prop] && row[col.prop] !== '-' && row.game_name !== '小计' && row.game_name !== '总计'">
              <span class="clickable-blue" @click="onCategoryClick(row[col.prop])">{{ row[col.prop] }}</span>
            </template>
            <template v-else>
              <span style="font-size:16px;">{{ row[col.prop] || '-' }}</span>
            </template>
          </div>

          <!-- 玩法名：点击跳转详情 -->
          <div v-else-if="col.prop === 'game_name' " style="font-size: 16px;">
            <template v-if="row.game_name && row.game_name !== '小计' && row.game_name !== '总计'">
              <span class="clickable-blue" @click="goGameInfo(row.game_name)">{{ row.game_name }}</span>
            </template>
            <template v-else>
              <span>{{ row.game_name }}</span>
            </template>
          </div>

          <!-- 指标 + 环比 -->
          <div v-else-if="col.customSlot" style="font-size: 16px;">
            <span
                v-if="col.prop==='anchor_score' && !(row.game_name==='小计'||row.game_name==='总计')"
                class="clickable-blue"
                @click="fetchAnchorData(row.game_name)"
            >
              {{ formatNumber(row[col.prop]?.value) }}
            </span>
            <span v-else>{{ formatNumber(row[col.prop]?.value) }}</span>
            <span
                v-if="row[col.prop]?.change !== 0"
                class="active-change"
                :class="{ 'red': row[col.prop]?.change > 0, 'green': row[col.prop]?.change < 0 }"
                style="font-size: 12px;"
            >
              ({{ row[col.prop]?.change > 200 ? '>200' : (row[col.prop]?.change < -200 ? '<-200' : row[col.prop]?.change) }}%)
            </span>
          </div>

          <!-- Mate三榜：玩法名 + 图标 -->
          <div v-else-if="col.prop === 'app_name'">
            <div style="display:flex;align-items:center;gap:8px;justify-content:center;">
              <img
                  v-if="row.icon_url"
                  :src="row.icon_url"
                  alt=""
                  style="width:28px;height:28px;border-radius:6px;object-fit:cover;"
              />
              <span class="clickable-blue" @click="goGameInfo(row.app_name)">{{ row.app_name }}</span>
            </div>
          </div>

          <!-- 普通列 -->
          <div v-else style="font-size: 16px;">{{ row[col.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 表格下方控制条 -->
    <div v-if="selectedTab !== '大盘数据'" style="text-align:right; margin-top:8px;">
      <el-link v-if="!showAll && tableData.length > 50" :underline="false" @click="showAll = true">
        <img :src="imgClickMore" alt="展开更多" style="height:28px; vertical-align:middle;" />
      </el-link>

      <el-link
          v-if="categoryFilter && selectedTab === '玩法榜'"
          :underline="false"
          @click="resetAllRank"
          style="margin-left:12px;"
      >
        <img :src="imgBackTotal" alt="返回全部排行榜" style="height:28px; vertical-align:middle;" />
      </el-link>
    </div>

    <!-- 活跃主播详情侧边栏 -->
    <el-drawer
        v-model="sidebarVisible"
        title="活跃主播详情"
        :direction="'rtl'"
        size="70%"
        :before-close="() => (sidebarVisible=false)"
        :style="{ position: 'fixed', top: drawerTop + 'px', zIndex: 1000, width: '70%'}"
    >
      <div :style="{ overflowY: 'auto', padding: '10px' }">
        <el-table :data="anchorList" stripe>
          <el-table-column label="排名" prop="index" width="80" />
          <el-table-column label="主播昵称" prop="nickname" />
          <el-table-column label="房间号" prop="room_id" />
          <el-table-column label="活跃度" prop="total_score" :formatter="formatTotalScore" />
        </el-table>
      </div>
      <div style="text-align:center; margin-top: 10px;">
        <el-pagination
            v-if="anchorPagination.total > 0"
            background
            layout="prev, pager, next, jumper"
            :total="anchorPagination.total"
            :page-size="anchorPagination.per_page"
            :current-page="anchorPagination.current_page"
            @current-change="handleAnchorPageChange"
        />
      </div>
      <template #footer>
        <el-button @click="sidebarVisible = false">关闭</el-button>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted, watch, onBeforeUnmount, computed } from 'vue'
import axios from 'axios'
import './common.css'
import './RankTable.css'
import { Datetime } from 'vue-datetime3'
import imgClickMore from '@/assets/click4more.png'
import imgBackTotal  from '@/assets/back2total.png'
import { Loading } from '@element-plus/icons-vue'

// === Mate 三榜常量 ===
const MATE_TYPES = ['热度榜','人气榜','效率榜']
const typeSlugMap = { '热度榜':'hot', '人气榜':'popular', '效率榜':'efficiency' }

// === 品类过滤（KS） ===
const categoryFilter = ref('')

function onCategoryClick(cat) {
  if (!cat || cat === '-') return
  categoryFilter.value = cat
  selectedTab.value = '玩法榜'
  selectedCategory.value = '玩法榜'
  isLoading.value = true
  fetchData()
}

function resetAllRank() {
  categoryFilter.value = ''
  showAll.value = false
  fetchData()
}

const isLoading = ref(false)
const selectedCategory = ref('玩法榜')
const categoryModalVisible = ref(false)
// 自定义查询可选类目：扩展包含 Mate 三榜
const categories = ['玩法榜', '主播榜', ...MATE_TYPES]
const searchQuery = ref('')

// 仅允许自定义查询页使用的榜单（用于校验与回退）
const VALID_CUSTOM_CATS = ['玩法榜', '主播榜', ...MATE_TYPES]

// 记住最近一次有效的“自定义查询”榜单（默认玩法榜）
const lastValidCustomCat = ref('玩法榜')

// 是否为 Mate 三榜（自定义查询界面用）
const isMateCategory = computed(() => MATE_TYPES.includes(selectedCategory.value))

// 输入占位提示
const inputPlaceholder = computed(() => {
  if (selectedCategory.value === '主播榜') return '主播昵称（可选）'
  if (MATE_TYPES.includes(selectedCategory.value)) return '玩法名（可选）'
  return '玩法或主播名'
})

// 展示时间
const displayTime = ref('')
function formatDisplay(date, hour, isEnd=false){
  const d=new Date(date)
  const y=d.getFullYear()
  let m=(d.getMonth()+1+'').padStart(2,'0')
  let day=(d.getDate()+'').padStart(2,'0')
  let h=hour?parseInt(hour,10):new Date().getHours()
  if(isEnd){ h=h-1; if(h<0){ d.setDate(d.getDate()-1); m=(d.getMonth()+1+'').padStart(2,'0'); day=(d.getDate()+'').padStart(2,'0'); h=23 } }
  return `${y}-${m}-${day} ${(h+'').padStart(2,'0')}:${isEnd?'59':'00'}`
}
function updateDisplayTime(){
  // 自定义查询 + Mate 三榜：仅显示“日期”
  if (selectedTab.value === '自定义查询' && isMateCategory.value) {
    const d = startDate.value ? new Date(startDate.value) : new Date()
    displayTime.value = `${d.getFullYear()}-${(d.getMonth()+1+'').padStart(2,'0')}-${(d.getDate()+'').padStart(2,'0')}`
    return
  }
  // 顶部 Mate 三榜 tab：同样仅显示“日期”
  if (isMateTab.value) {
    const d = startDate.value ? new Date(startDate.value) : new Date()
    displayTime.value = `${d.getFullYear()}-${(d.getMonth()+1+'').padStart(2,'0')}-${(d.getDate()+'').padStart(2,'0')}`
    return
  }
  // 其它场景：显示起止小时段
  const start=(startDate.value&&startHour.value)?formatDisplay(startDate.value,startHour.value,false):formatDisplay(new Date(), new Date().getHours(), false)
  const end  =(endDate.value  &&endHour.value  )?formatDisplay(endDate.value  ,endHour.value  ,true ):formatDisplay(new Date(), new Date().getHours(), true)
  displayTime.value=`${start} - ${end}`
}

function selectCategory(c){ selectedCategory.value=c; categoryModalVisible.value=false }
function showCategoryModal(){ categoryModalVisible.value = true }

// 顶部tab
const tabs = ['玩法榜','主播榜','热度榜','人气榜','效率榜','自定义查询']
const selectedTab = ref('玩法榜')

// 列配置
const columnsMap = {
  '玩法榜': [
    { label: '预测', prop: 'rank', width: '60' },
    { label: '玩法名称', prop: 'game_name', minWidth: '60' },
    { label: '类型', prop: 'category', minWidth: '50' },
    { label: '活跃主播', prop: 'anchor_num', minWidth: '60' },
    { label: '主播榜活跃', prop: 'anchor_score', minWidth: '100', customSlot: true },
    { label: '玩法榜活跃', prop: 'game_score_total', minWidth: '100', customSlot: true },
    { label: '昨日畅销', prop: 'yesterday_hot_rank', minWidth: '80' },
  ],
  '主播榜': [
    { label: '排名', prop: 'rank', width: '60' },
    { label: '玩法名称', prop: 'game_name', minWidth: '120' },
    { label: '主播昵称', prop: 'nickname', minWidth: '120' },
    { label: '活跃度（万）', prop: 'score_str', minWidth: '120' },
  ],
  '热度榜': [
    { label: '排名', prop: 'rank', width: '70' },
    { label: '玩法', prop: 'app_name', minWidth: '160' },
    { label: '简介', prop: 'description', minWidth: '260' },
  ],
  '人气榜': [
    { label: '排名', prop: 'rank', width: '70' },
    { label: '玩法', prop: 'app_name', minWidth: '160' },
    { label: '简介', prop: 'description', minWidth: '260' },
  ],
  '效率榜': [
    { label: '排名', prop: 'rank', width: '70' },
    { label: '玩法', prop: 'app_name', minWidth: '160' },
    { label: '简介', prop: 'description', minWidth: '260' },
  ],
  '自定义查询': [],
}

// 数据 & “展开更多”
const tableData = ref([])
const showAll = ref(false)
const visibleRows = computed(() => showAll.value ? tableData.value : tableData.value.slice(0,50))

// 侧边栏
const sidebarVisible = ref(false)
const anchorList = ref([])
const anchorPagination = ref({ current_page:1, per_page:50, total:0, last_page:1 })
const currentGameName = ref('')

function goGameInfo(name){
  if(!name) return
  window.location.href = `/new_game_info?game_name=${encodeURIComponent(name)}`
}

function fetchAnchorData(gameName, page=1){
  const params = {
    start_time: formatDateTime(startDate.value, startHour.value),
    end_time:   formatDateTime(endDate.value,   endHour.value),
    game_name:  gameName,
    page
  }
  currentGameName.value = gameName
  axios.get('https://www.hudongwanfa.cn/api/ks_anchor_game_rank', { params }).then(res=>{
    const responseData = res.data.data
    anchorPagination.value = responseData.meta
    anchorList.value = responseData.data.map(x=>({ ...x, total_score: formatScoreStr(x.total_score) }))
    sidebarVisible.value = true
  }).catch(()=>{})
}
function handleAnchorPageChange(p){ fetchAnchorData(currentGameName.value, p) }

// 时间 & 查询
const startDate = ref(''), startHour = ref(''), endDate = ref(''), endHour = ref(''), quickSelect = ref('')

function onTabClick(tab){
  if (tab !== '自定义查询') {
    columnsMap['自定义查询'] = columnsMap[tab]
    selectedCategory.value = tab
    if (VALID_CUSTOM_CATS.includes(tab)) {
      lastValidCustomCat.value = tab
    }
  }

  if (tab === '自定义查询') {
    initTodayTime()
    if (!VALID_CUSTOM_CATS.includes(selectedCategory.value)) {
      selectedCategory.value = lastValidCustomCat.value
    }
    columnsMap['自定义查询'] = columnsMap[selectedCategory.value]
  }

  selectedTab.value = tab

  if (tab !== '自定义查询') {
    initTodayTime()
    searchQuery.value = ''
    quickSelect.value = ''
  }
  categoryFilter.value = ''
}

watch(selectedCategory, (val) => {
  if (VALID_CUSTOM_CATS.includes(val)) {
    lastValidCustomCat.value = val
  }
  if (selectedTab.value === '自定义查询') {
    columnsMap['自定义查询'] = columnsMap[val] || columnsMap['玩法榜']
  }
})

watch(selectedTab, ()=>{ if(selectedTab.value !== '自定义查询') fetchData() })

function fetchData(){
  isLoading.value = true
  showAll.value = false
  updateDisplayTime()

  // 顶部切换到 Mate 三榜：按日榜
  if (isMateTab.value) { fetchMateData(); return }

  if (selectedTab.value === '主播榜') {
    axios.get('https://www.hudongwanfa.cn/api/ks_anchor_rank', {
      params: {
        nickname:   searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value),
        end_time:   formatDateTime(endDate.value,   endHour.value),
      }
    }).then(res=>{
      const data = res.data.data || []
      tableData.value = data.map(x=>({
        rank: x.index, game_name: x.game_name, nickname: x.nickname, score_str: formatScoreStr(x.score_str)
      }))
      isLoading.value=false
    }).catch(()=>{ isLoading.value=false })
  } else if (selectedTab.value === '玩法榜') {
    axios.get('https://www.hudongwanfa.cn/api/ks_game_rank', {
      params: {
        app_name:   searchQuery.value,
        start_time: formatDateTime(startDate.value, startHour.value),
        end_time:   formatDateTime(endDate.value,   endHour.value),
        category:   categoryFilter.value || undefined
      }
    }).then(async (res)=>{
      const data = res.data.data?.data || res.data.data || []
      tableData.value = await asGameplayRows(data)
      isLoading.value=false
    }).catch(()=>{ isLoading.value=false })
  }
}

function formatDateTime(date, hour){
  if(!date) return ''
  const d=new Date(date)
  const Y=d.getFullYear(), M=(d.getMonth()+1+'').padStart(2,'0'), D=(d.getDate()+'').padStart(2,'0')
  const H=hour?hour:'00'
  return `${Y}-${M}-${D} ${H}:00:00`
}

watch(quickSelect,(v)=>{
  const now = new Date()
  const midnight = (dt)=> new Date(dt.setHours(0,0,0,0))
  let s,e
  if(v==='yesterday'){ s=midnight(new Date(now.setDate(now.getDate()-1))); e=midnight(new Date()) }
  else if(v==='beforeYesterday'){ const two=new Date(now); two.setDate(now.getDate()-2); s=midnight(two); const y=new Date(now); y.setDate(now.getDate()-1); e=midnight(y) }
  else { s=midnight(new Date()); e=midnight(new Date(now.setDate(now.getDate()+1))) }
  startDate.value = formatDateString(s); startHour.value = formatHourString(s.getHours())
  endDate.value   = formatDateString(e); endHour.value   = formatHourString(e.getHours())
})

function onSearch(){
  // Mate 三榜在“自定义查询”下仅按日期查询，无需修正小时
  if (!(selectedTab.value === '自定义查询' && isMateCategory.value)) {
    const now=new Date()
    const currHour = new Date(now.getFullYear(),now.getMonth(),now.getDate(),now.getHours(),0,0,0)
    const nextHour = new Date(now.getFullYear(),now.getMonth(),now.getDate(),now.getHours()+1,0,0,0)

    const sdt=new Date(startDate.value+' '+startHour.value+':00:00')
    if(sdt>currHour){ startDate.value=formatDateString(now); startHour.value=(currHour.getHours()+'').padStart(2,'0') }

    const edt=new Date(endDate.value+' '+endHour.value+':00:00')
    if(edt>nextHour){ endDate.value=formatDateString(now); endHour.value=(nextHour.getHours()+'').padStart(2,'0') }
  }

  if (selectedTab.value === '自定义查询') {
    const cat = VALID_CUSTOM_CATS.includes(selectedCategory.value) ? selectedCategory.value : lastValidCustomCat.value
    selectedCategory.value = cat
    columnsMap['自定义查询'] = columnsMap[cat]
    tableData.value = []
    fetchDataByCategory()
  } else {
    fetchData()
  }
}

function getRowClassName({ rowIndex }){ return rowIndex%2===0?'even-row':'odd-row' }
function formatNumber(v){ return v ?? '-' }
function formatScoreStr(s){ const n=+s; return Number.isFinite(n) && n>=10000? (n/10000).toFixed(1)+'万' : s }
function headerCellStyle(){ return { backgroundColor:'#4a649e', color:'white', fontWeight:'bold', textAlign:'center', fontSize:'16px' } }
function headerRowStyle(){ return { backgroundColor:'#f2f2f2', fontWeight:'bold' } }
function formatTotalScore(_row, _col, val){ return val }

// 初始时间
function initTodayTime(){
  const now=new Date()
  const s=new Date(now); s.setHours(0,0,0,0)
  startDate.value = formatDateString(s); startHour.value='00'
  const e=new Date(now); e.setHours(now.getHours()+1,0,0,0)
  endDate.value = formatDateString(e); endHour.value=(e.getHours()+'').padStart(2,'0')
}

onMounted(()=>{
  initTodayTime(); fetchData()
  window.addEventListener('resize', updateContentHeight)
  observer = new MutationObserver(updateContentHeight)
  observer.observe(document.body, {attributes:true, childList:true, subtree:true})
})

function formatDateString(d){ const x=new Date(d); return `${x.getFullYear()}-${(x.getMonth()+1+'').padStart(2,'0')}-${(x.getDate()+'').padStart(2,'0')}` }
function formatHourString(h){ return h? h : '00' }

// 自定义查询的按类目取数
function fetchDataByCategory(){
  isLoading.value = true; showAll.value=false; updateDisplayTime();
  if(selectedCategory.value==='主播榜'){
    axios.get('https://www.hudongwanfa.cn/api/ks_anchor_rank',{
      params:{ nickname:searchQuery.value, start_time:formatDateTime(startDate.value,startHour.value), end_time:formatDateTime(endDate.value,endHour.value) }
    }).then(res=>{
      const data = res.data.data || []
      tableData.value = data.map(x=>({ rank:x.index, game_name:x.game_name, nickname:x.nickname, score_str:formatScoreStr(x.score_str) }))
      isLoading.value=false
    }).catch(()=>{ isLoading.value=false })
  } else if (selectedCategory.value==='玩法榜') {
    axios.get('https://www.hudongwanfa.cn/api/ks_game_rank',{
      params:{
        app_name:searchQuery.value,
        start_time:formatDateTime(startDate.value,startHour.value),
        end_time:formatDateTime(endDate.value,endHour.value),
        category: categoryFilter.value || undefined
      }
    }).then(async res=>{
      const data = res.data.data?.data || res.data.data || []
      tableData.value = await asGameplayRows(data)
      isLoading.value=false
    }).catch(()=>{ isLoading.value=false })
  } else if (MATE_TYPES.includes(selectedCategory.value)) {
    // 自定义查询里查 Mate 三榜
    fetchMateData()
  } else {
    isLoading.value=false
  }
}

// 小屏尺寸调整
const contentHeight = ref(window.innerHeight), drawerTop = ref(0)
const updateContentHeight = ()=>{
  const w=window.innerWidth
  if(w<=768){ contentHeight.value = 768/window.innerWidth*window.innerHeight - 120; drawerTop.value = 768/window.innerWidth*window.scrollY; }
}
let observer=null
onBeforeUnmount(()=>{ window.removeEventListener('resize', updateContentHeight); if(observer) observer.disconnect() })

// --- 自动补全（KS） ---
const filteredSuggestions = ref([])
const showSuggestions = ref(false)
const autocompleteInput = ref(null)
const dropdownStyle = reactive({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  background: '#fff',
  border: '1px solid #ccc',
  maxHeight: '200px',
  overflowY: 'auto',
  zIndex: 1000,
})

const onSearchInput = async () => {
  const q = searchQuery.value.trim()
  if (!q) { filteredSuggestions.value = []; return }
  try {
    const res = await axios.get('https://www.hudongwanfa.cn/api/search_game_ks', { params: { game_name: q } })
    filteredSuggestions.value = (res.data?.data || []).map(x => ({ label: x.game_name, value: x.game_name }))
    if (filteredSuggestions.value.length) { showSuggestions.value = true; adjustDropdownPosition() }
  } catch { /* 忽略 */ }
}
const showDropdown = () => { showSuggestions.value = true; adjustDropdownPosition() }
const hideSuggestions = () => { setTimeout(() => { showSuggestions.value = false }, 100) }
const onGameSelect = (it) => { searchQuery.value = it.value; showSuggestions.value = false }
const adjustDropdownPosition = () => {
  nextTick(() => {
    if (!autocompleteInput.value) return
    const r = autocompleteInput.value.getBoundingClientRect()
    dropdownStyle.top = r.bottom + 'px'
    dropdownStyle.left = r.left + 'px'
    dropdownStyle.width = r.width + 'px'
  })
}

// === Mate 三榜（热度/人气/效率） ===
const isMateTab = computed(() => MATE_TYPES.includes(selectedTab.value))
const mateSummary = ref({ hot: [], popular: [], efficiency: [] })
const mateLoadedDate = ref('')
const usingSummary = ref(false)

function rankDateStr() {
  // 自定义查询 + Mate / 顶部 Mate：均以 startDate 为“日期”
  if (startDate.value) return formatDateString(startDate.value)
  const now = new Date(); return formatDateString(now)
}
function mapMateRows(list) {
  return (list || []).map((x, i) => ({
    rank: x.rank_index ?? (i + 1),
    app_name: x.app_name,
    icon_url: x.icon_url,
    description: x.description || '-',
  }))
}
async function fetchMateData() {
  isLoading.value = true
  showAll.value = false
  updateDisplayTime()

  const date = rankDateStr()
  // 在“自定义查询”下，用 selectedCategory 判定 slug；在顶部 tab 下用 selectedTab
  const currType = selectedTab.value === '自定义查询' ? selectedCategory.value : selectedTab.value
  const slug = typeSlugMap[currType]

  if (usingSummary.value && mateLoadedDate.value === date) {
    tableData.value = mapMateRows(mateSummary.value[slug])
    isLoading.value = false
    return
  }

  // 1) 汇总接口
  try {
    const res = await axios.get('https://www.hudongwanfa.cn/api/ks_mate_summary', { params: { date } })
    const payload = res.data?.data || res.data || {}
    if (payload.hot && payload.popular && payload.efficiency) {
      mateSummary.value = payload
      mateLoadedDate.value = date
      usingSummary.value = true
      tableData.value = mapMateRows(payload[slug])
      isLoading.value = false
      return
    }
  } catch { /* 降级 */ }

  // 2) 降级单榜
  usingSummary.value = false
  try {
    const res = await axios.get(`https://www.hudongwanfa.cn/api/ks_mate_data/${slug}`, {
      params: { date, app_name: (searchQuery.value || undefined) }
    })
    const list = res.data?.data || res.data || []
    tableData.value = mapMateRows(list)
  } finally {
    isLoading.value = false
  }
}

// === 小时/快速选择弹窗：状态 + 处理函数（KS） ===
const hourModalVisible = ref(false)
const quickSelectModalVisible = ref(false)
const selectingHourFor = ref('')

// 显示选择小时模态框
function showHourModal(type) {
  selectingHourFor.value = type;
  hourModalVisible.value = true;
}

// 在小时弹窗中点某个小时
function selectHour(hour) {
  if (selectingHourFor.value === 'start') {
    startHour.value = hour.toString().padStart(2, '0');
  } else {
    endHour.value = hour.toString().padStart(2, '0');
  }
  hourModalVisible.value = false;
}

// 点击“快速选择”按钮
function showQuickSelectModal() {
  quickSelectModalVisible.value = true
}

// “快速选择”弹窗点击“确定”
function confirmQuickSelect() {
  quickSelectModalVisible.value = false
  // 具体日期赋值逻辑走 watch(quickSelect)
}

const quickOptions = [
  { label: '今天', value: 'today' },
  { label: '昨天', value: 'yesterday' },
  { label: '前天', value: 'beforeYesterday' }
]

// 小工具：把 /api/ks_game_rank 的返回映射成表格行，并注入昨日畅销
async function asGameplayRows(data) {
  return (data || []).map(item => ({
        rank: item.rank,
        game_name: item.game_name,
        category: item.category,
        anchor_num: item.anchor_num,
        game_score_total: {
          value: item.game_score_total > 10000 ? (item.game_score_total/10000).toFixed(1)+'万' : item.game_score_total,
          change: item.game_score_change
        },
        anchor_score: {
          value: item.anchor_score > 10000 ? (item.anchor_score/10000).toFixed(1)+'万' : item.anchor_score,
          change: item.anchor_score_change
        },
        // 关键：透传后端的 hot_rank_today（为空则用 '-' 兜底）
        yesterday_hot_rank: (item.hot_rank_today ?? '-')
  }))
}
</script>

<style scoped>
.custom-autocomplete{ position:relative; display:inline-block; width:100%; box-sizing:border-box; }
.autocomplete-input{ width:100%; padding:8px; font-size:16px; box-sizing:border-box; }
.autocomplete-dropdown{ position:absolute; top:100%; left:0; width:100%; max-height:250px; overflow-y:auto; background:#fff; border:1px solid #ccc; box-shadow:0 2px 8px rgba(0,0,0,0.15); z-index:10; box-sizing:border-box; }
.autocomplete-dropdown ul{ margin:0; padding:0; list-style:none; }
.autocomplete-dropdown li{ padding:6px 12px; cursor:pointer; }
.autocomplete-dropdown li:hover{ background-color: #f5f5f5; }

.hour-selector { display: flex; flex-wrap: wrap; justify-content: space-between; }
.clickable-blue{ color:#409EFF; cursor:pointer; }
.active-change.red{ color:#f56c6c; }
.active-change.green{ color:#67c23a; }
.even-row{ background: rgba(255,255,255,0.04); }
.odd-row{ background: rgba(0,0,0,0.04); }

</style>
